import {GetOdontoSpecialtiesParams} from 'domain/usecases';
import {makeGetOdontoSpecialties} from 'main/factories/usecases';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {categorizeSpecialtiesByFirstLetter, sortByKey, Specialty} from 'presentation/utils';

export async function getOdontoSpecialties(params: GetOdontoSpecialtiesParams) {
	const response = await makeGetOdontoSpecialties().get(params);

	if (!response) {
		return [];
	}

	const specialties = response.especialidades;

	const parsedSpecialties: Specialty<FlowEnum.ODONTO>[] = specialties.flatMap(specialty => {
		if (specialty?.subEspecialidades?.length === 0 || !specialty?.subEspecialidades) {
			return {
				code: specialty.cdEspecialidade.toString(),
				description: specialty.dsEspecialidade,
				telemedicine: specialty.telemedicina,
				formattedText: specialty.dsEspecialidade,
			};
		}
		return specialty?.subEspecialidades?.map(sub => ({
			code: specialty.cdEspecialidade.toString(),
			description: specialty.dsEspecialidade,
			sub_code: sub.cdSubEspecialidade.toString(),
			sub_description: sub.dsSubEspecialidade,
			telemedicine: specialty.telemedicina,
			formattedText: `${specialty.dsEspecialidade} - ${sub.dsSubEspecialidade}`,
		}));
	});
	const sortedSpecialtiesByName =
		parsedSpecialties && sortByKey(parsedSpecialties, 'formattedText');
	const categorizedSpecialties =
		sortedSpecialtiesByName && categorizeSpecialtiesByFirstLetter(sortedSpecialtiesByName);

	return categorizedSpecialties;
}
